var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailIcon20201(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_1497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28786 16H5.6818V7.75758L0.833313 4.12122V14.5455C0.833313 15.3503 1.48543 16 2.28786 16Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3182 16H20.7121C21.517 16 22.1667 15.3479 22.1667 14.5455V4.12122L17.3182 7.75758",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3182 1.45452V7.75755L22.1667 4.12119V2.18179C22.1667 0.383006 20.1133 -0.642448 18.6758 0.436339",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68182 7.75762V1.45459L11.5 5.81823L17.3182 1.45459V7.75762L11.5 12.1213",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 2.18179V4.12119L5.6818 7.75755V1.45452L4.32422 0.436339C2.88422 -0.642448 0.833313 0.383006 0.833313 2.18179Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_1497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 16,
    fill: "white",
    transform: "translate(0.833313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon20201);
export default __webpack_public_path__ + "static/media/Gmail_icon_(2020) 1.9c8eaacb13a1ac2cd94516204bcb0c22.svg";
export { ForwardRef as ReactComponent };